import React from 'react';
import { NormalizedCacheObject } from 'apollo-cache-inmemory';
import ApolloClient from 'apollo-client';
import { MockApolloClient } from 'mock-apollo-client';

import { SessionDetails } from '../ScheduleSessionForm/constants';
import ReminderModal from '../ReminderModal/ReminderModal';
import {
  PaymentReminderTestID,
  ReminderSuccessContentTestID,
  SendReminderContentTestID,
} from './constants';

export interface Props {
  isCanceling: boolean;
  memberClient: ApolloClient<NormalizedCacheObject> | MockApolloClient;
  onCancel: () => void;
  onSuccess: () => void;
  sessionDetails: SessionDetails;
}

const PaymentReminder: React.FC<Props> = ({
  isCanceling,
  memberClient,
  onCancel,
  onSuccess,
  sessionDetails,
}) => (
  <ReminderModal
    dataTestid={PaymentReminderTestID}
    isCanceling={isCanceling}
    memberClient={memberClient}
    onCancel={onCancel}
    onSuccess={onSuccess}
    reminderSuccessContent={
      <>
        <div
          className="font-normal text-gray-800 text-base mb-6"
          data-testid={ReminderSuccessContentTestID}
        >
          Once your client’s payment information has been submitted we’ll email you with session
          confirmation. If their information is not completed within <b>48 hours</b>, the time slot
          will no longer be reserved and other clients will be able to book this time.
        </div>
      </>
    }
    sendReminderContent={
      <>
        <div
          className="font-normal text-gray-800 text-base mb-6"
          data-testid={SendReminderContentTestID}
        >
          To book this session, your client needs to submit their payment information through Modern
          Health’s website. By selecting to reserve a session, a reminder will be sent for them to
          complete this information.
        </div>
      </>
    }
    sessionDetails={sessionDetails}
  />
);

export default PaymentReminder;
